module.exports = __webpack_public_path__ + "static/calendar_preset_select-5336b57c7969178c8a2f5b0ee89a41d9.png";